module.exports = __webpack_public_path__ + "img/ic_appstore_apple.e8ac9fad.svg";